import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  EDIT_TRANSLATIONS_FAILURE,
  EDIT_TRANSLATIONS_REQUEST,
  EDIT_TRANSLATIONS_SUCCESS,
  CLEAR_PRESERVED_IMPC,
} from '../actions/types/MrdAppTranslationsActionsTypes';

export const initialState = {
  editTranslationsLoading: false,
  impcCode: null,
};

const TranslationsReducer = (state = initialState, action) => {
  switch (action.type) {
  case EDIT_TRANSLATIONS_REQUEST:
    return {
      ...state,
      editTranslationsLoading: true,
      impcCode: action.payload[0].impcCode,
    };
  case EDIT_TRANSLATIONS_SUCCESS:
    return {
      ...state,
      editTranslationsLoading: false,
    };
  case EDIT_TRANSLATIONS_FAILURE:
    return {
      ...state,
      editTranslationsLoading: false,
    };
  case CLEAR_PRESERVED_IMPC:
    return {
      ...state,
      impcCode: null,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default TranslationsReducer;
